{
  "longPressMessage": "לחץ לחיצה ארוכה או הקש Alt + ArrowDown כדי לפתוח את התפריט"
}
